import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import CameraAltRoundedIcon from '@mui/icons-material/CameraAltRounded';
import VolunteerActivismRoundedIcon from '@mui/icons-material/VolunteerActivismRounded';
import FlatwareIcon from '@mui/icons-material/Flatware';
import CelebrationIcon from '@mui/icons-material/Celebration';
import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import { useT } from 'talkr';

export default function CustomizedTimeline() {
  const { T } = useT();

  const timeLineItems = [
    {
      time: '15:30',
      icon: <VolunteerActivismRoundedIcon />,
      text: T('program_list.wedding_ceremony'),
    },
    {
      time: '16:00',
      icon: <CameraAltRoundedIcon />,
      text: T('program_list.party_tram'),
    },
    {
      time: '17:00',
      icon: <FlatwareIcon />,
      text: T('program_list.wedding_dinner'),
    },
    {
      time: '19:00',
      icon: <CelebrationIcon />,
      text: T('program_list.party'),
    },
    {
      time: '00:00',
      icon: <AllInclusiveRoundedIcon />,
      text: T('program_list.sunrise_welcome'),
    },
  ];

  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 2,
          padding: 2,
        },
      }}
    >
      {timeLineItems.map((item, index) => (
        <TimelineItem key={index} sx={{ mb: { xs: 1, sm: 1.5, md: 1 }, minHeight: 'auto' }}>



 <TimelineOppositeContent sx={{  alignItems: 'center', py: 3 }}>
            <Typography sx={{ fontWeight: 'medium', fontSize: { xs: '0.875rem', sm: '1rem', md: '1.125rem' },  flex: 4 }}>
            {item.time}
            </Typography>
          </TimelineOppositeContent>


          <TimelineSeparator>
            <TimelineDot
              sx={{
                backgroundColor: 'primary.main',
               // display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: { xs: 40, sm: 44, md: 48 },
                height: { xs: 40, sm: 44, md: 48 },
              }}
              variant="filled"
            >
              {item.icon}
            </TimelineDot>
            {index !== timeLineItems.length - 1 && (
              <TimelineConnector
                sx={{
                  height: { xs: '30px', sm: '35px', md: '30px' },
                }}
              />
            )}
          </TimelineSeparator>
          <TimelineContent sx={{  alignItems: 'top', py: 3 }}>
            <Typography sx={{ fontWeight: 'medium', fontSize: { xs: '0.875rem', sm: '1rem', md: '1.125rem' }, flex: 1  }}>
              {item.text}
            </Typography>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}